<template>
  <scoped>
    <div
      ref="component"
      class="foldable-content"
    >
      <Button
        :image="image"
        :title="title"
        @click="toggle()"
      />
      <div
        class="content"
        :class="[visible ? 'visible' : null]"
      >
        <slot />
      </div>
    </div>
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import {onUnmounted, ref, useTemplateRef} from "vue"
  
  defineProps({
    image: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  })
  
  onUnmounted(() => {
    removeEventListener("click", outsideClick)
  })
  
  const component = useTemplateRef("component")
  const visible = ref<boolean>(false)
  
  function outsideClick() {
    if (component.value.matches(":hover")) {
      return
    }
    toggle()
  }
  
  function toggle() {
    if (visible.value) {
      visible.value = false
      removeEventListener("click", outsideClick)
    } else {
      visible.value = true
      addEventListener("click", outsideClick)
    }
  }
</script>

<style scoped>
  .foldable-content {
    display: inline-block;
  
    .content {
      border-color: var(--theme-color-primary);
      border-radius: var(--border-radius-small);
      border-style: solid;
      border-width: var(--border-width-light);
      display: none;
      padding: 0.5em;
      position: absolute;
      z-index: 2;
  
      &.visible {
        display: block;
      }
    }
  }
</style>
